/* GoogleMapOneFacility ID is used here to migrate all the
GoogleMapOneFacility widgets to MapboxOneFacility widgets */
export const ID = '3534c707-1f57-4962-849e-7b51c69c9804';
export const NAME = 'Map: One Facility';
